module.exports = __webpack_public_path__ + "img/advantage1_2@2x.c2ab60a0.png";